import React from 'react';

class ResOrcTable extends React.Component {

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    formatarValor(s) {

        if (s === null || s === "") return "";
        else if (s === 0) return "0,00";

        return this.moneyMask(s);

    }

    render() {
        return(
            <div>
                <table Class={ "resumo-anual-res-tbl" }>
                    <thead>
                        <tr Style={ "background: #ddddff;" }>
                            <th>COD-CONTA</th>
                            <th>CONTA</th>
                            <th>COMENTÁRIO (Orçamento)</th>
                            <th colspan="3">01</th>
                            <th colspan="3">02</th>
                            <th colspan="3">03</th>
                            <th colspan="3">04</th>
                            <th colspan="3">05</th>
                            <th colspan="3">06</th>
                            <th colspan="3">07</th>
                            <th colspan="3">08</th>
                            <th colspan="3">09</th>
                            <th colspan="3">10</th>
                            <th colspan="3">11</th>
                            <th colspan="3">12</th>
                            <th colspan="3">TOTAL</th>
                        </tr>
                        <tr Style={ "background: #ddddff;" }>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                            <th>ORÇADO</th>
                            <th>REAL</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.props.resumoAnual.tipo_contas.map((item, i) => {
                            return [
                                <tr key={ i } Style={ "background: " + item.cor + ";" }>
                                    <td><b>{ item.cod_conta }</b></td>
                                    <td><b>{ item.nome }</b></td>
                                    <td></td>
                                    <td>{ this.formatarValor(item.soma_total_orc[0]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[0]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[0]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[1]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[1]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[1]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[2]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[2]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[2]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[3]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[3]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[3]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[4]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[4]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[4]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[5]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[5]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[5]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[6]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[6]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[6]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[7]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[7]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[7]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[8]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[8]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[8]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[9]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[9]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[9]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[10]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[10]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[10]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[11]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[11]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[11]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_orc[12]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[12]) }</td>
                                    <td>{ this.formatarValor(item.soma_total_perc[12]) }</td>
                                </tr>,
                                item.contas.map((item2, j) => {
                                    return [
                                        <tr key={ j }>
                                            <td><b>{ item2.cod_conta }</b></td>
                                            <td><b>{ item2.conta }</b></td>
                                            <td>{ item2.orcamento[13] }</td>
                                            <td>{ this.formatarValor(item2.orcamento[0]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[0]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[0]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[1]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[1]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[1]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[2]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[2]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[2]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[3]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[3]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[3]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[4]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[4]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[4]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[5]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[5]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[5]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[6]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[6]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[6]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[7]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[7]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[7]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[8]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[8]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[8]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[9]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[9]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[9]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[10]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[10]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[10]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[11]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[11]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[11]) }</td>
                                            <td>{ this.formatarValor(item2.orcamento[12]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[12]) }</td>
                                            <td>{ this.formatarValor(item2.percentual[12]) }</td>
                                        </tr> 
                                    ];
                                }),
                                <tr>
                                    <td><b></b></td>
                                    <td><b></b></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            ];
                        })}
                        <tr Style={ "background: #ccccff;" }>
                            <td><b></b></td>
                            <td><b>TOTAL SAÍDAS</b></td>
                            <td></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_orc[12]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[12]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas_perc[12]) }</td>
                        </tr>
                        <tr Style={ "background: #ccccff;" }>
                            <td><b></b></td>
                            <td><b>SALDO FINAL</b></td>
                            <td></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_orc[12]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[12]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final_perc[12]) }</td>
                        </tr>
                    </tbody>
                </table><br /><br />
            </div>
        );
    }

}

export default ResOrcTable;

